<template>
  <Dialog
    :title="type === 'add' ? '新增广告' : '修改广告'"
    :visible.sync="dialogVisible"
    width="640px"
    :close-on-click-modal="false"
    :before-close="cancel"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="标题" prop="title">
        <el-input
          v-model.trim="form.title"
          maxlength="20"
          show-word-limit
          placeholder="请输入标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="封面" prop="imageUrl">
        <UploadFile
          v-model="form.imageUrl"
          :limit="1"
          :maxSize="5"
          accept="image/*"
          :fileTypes="['jpg', 'jpeg', 'png', 'gif', 'webp']"
          @input="$refs.formRef && $refs.formRef.validateField('imageUrl')"
        ></UploadFile>
      </el-form-item>
      <el-form-item label="链接名称" prop="linkName">
        <el-input
          v-model.trim="form.linkName"
          maxlength="50"
          placeholder="请输入链接名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="跳转链接" prop="link">
        <el-input
          v-model.trim="form.link"
          maxlength="500"
          placeholder="请输入跳转链接"
        ></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number
          v-model="form.sort"
          :min="0"
          :max="9999"
          controls-position="right"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">启用</el-radio>
          <el-radio :label="1">停用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="截止日期" prop="endTime">
        <el-date-picker
          v-model="form.endTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择截止日期"
          :picker-options="endTimePickerOptions"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button plain round size="small" @click="cancel">取 消</el-button>
      <el-button
        plain
        round
        size="small"
        type="primary"
        :loading="submitLoading"
        @click="submitForm"
        >确 定</el-button
      >
    </div>
  </Dialog>
</template>

<script>
import UploadFile from "@/components/UploadFile";
import { addBanner, updateBanner } from "@/api/content/banner";

const defaultForm = () => ({
  bannerId: undefined,
  title: "",
  imageUrl: "",
  link: "",
  linkName: "",
  sort: 0,
  status: 0,
  endTime: ""
});

export default {
  name: "BannerForm",
  components: {
    UploadFile
  },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      type: "add",
      form: defaultForm(),
      endTimePickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        }
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        imageUrl: [
          { required: true, message: "请上传封面", trigger: "change" }
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        sort: [{ required: true, message: "请输入排序", trigger: "change" }]
      }
    };
  },
  methods: {
    formatEndTimeForForm(value) {
      if (!value) return "";
      return String(value).slice(0, 10);
    },
    formatEndTimeForApi(value) {
      if (!value) return "";
      const day = String(value).slice(0, 10);
      return `${day} 00:00:00`;
    },
    open(type, row = {}) {
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit" && row.bannerId != null) {
        this.form = {
          bannerId: row.bannerId,
          title: row.title || "",
          imageUrl: row.imageUrl || "",
          link: row.link || "",
          linkName: row.linkName || "",
          sort: row.sort != null ? row.sort : 0,
          status: row.status != null ? Number(row.status) : 0,
          endTime: this.formatEndTimeForForm(row.endTime)
        };
      } else {
        this.form = defaultForm();
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    async submitForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.formRef.validate();
      } catch (e) {
        return;
      }
      this.submitLoading = true;
      const request = this.form.bannerId ? updateBanner : addBanner;
      const payload = {
        ...this.form,
        endTime: this.formatEndTimeForApi(this.form.endTime)
      };
      try {
        await request(payload);
        this.$message.success(this.form.bannerId ? "修改成功" : "新增成功");
        this.cancel();
        this.$emit("success");
      } catch (e) {
      } finally {
        this.submitLoading = false;
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.form = defaultForm();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Banner/BannerForm.vue